module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1063-retro.23727d92.jpg";